import InnerPageBanner from "parts/innerPageBanner";
import MainContent from "./mainContent";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
// import ContactMap from "./contactMap";

export const ContactLayout = () => {
  return (
    <>
      <section>
        <section>
          <InnerPageBanner
            image="/product-detail.jpeg"
            title="Contact us"
            // button={{ text: "Write a mail", icon: <MailOutlineIcon /> }}
            // link="mailto:admin@talkiomobile.com"
          />
        </section>
      </section>
      <section>
        <MainContent />
      </section>
      <section>{/* <ContactMap image="/contactMap.png" /> */}</section>
    </>
  );
};
